import Input, { createProps as createInputProps } from './Input'
import CheckboxGroup from './CheckboxGroup'
import RadioGroup from './RadioGroup'
import * as Hooks from '../../hooks'

export default function Control({ widget, ...props }) {
    const { name } = props
    const { schema } = Hooks.useSubSchema(name)
    const Widget = Hooks.useWidget(widget?.name)

    if (!schema) {
        throw new TypeError('Schema do not exist for property = ' + name)
    }

    if (Widget) {
        return <Widget props={props} options={widget.options} />
    }

    if ('options' in props) {
        switch (schema.type) {
            case 'array':
                return <CheckboxGroup {...props} />
            case 'string':
                return <RadioGroup {...props} />
            default:
                break
        }
    }

    return <Input {...props} {...createInputProps(schema)} />
}
